import { EstateTypeNameEnum } from "common/enums/EstateTypeEnum";
import { useCallback, useEffect, useState } from "react";
import { EstateTypeSelectDialogProps } from "./interfaces";

export const useEstateTypeSelectDialogHooks = (
  props: EstateTypeSelectDialogProps
) => {
  const [estateTypes, setEstateTypes] = useState<
    EstateTypeSelectDialogProps["estateTypes"]
  >(props.estateTypes);
  const [busy, setBusy] = useState(false);

  const onModeClick = useCallback((estateType: EstateTypeNameEnum) => {
    setEstateTypes((prev) => {
      if (prev.includes(estateType)) {
        return prev.filter((v) => v !== estateType).slice();
      } else {
        return [...prev, estateType];
      }
    });
  }, []);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    setTimeout(() => setEstateTypes(props.estateTypes), 0);
  }, [props.estateTypes]);

  useEffect(() => {
    if (busy) {
      props.onOkClick(estateTypes);
      setTimeout(() => setBusy(false), 0);
    }
  }, [busy, estateTypes, props]);

  return { estateTypes, busy, onModeClick, onOkClick } as const;
};
